import{AUTH_CONFIG}from"../../config/appConfig";// Local storage keys
const AUTH_ENABLED_KEY='auth_enabled';const DEBUG_TOKEN_KEY='debug_token';/**
 * Check if authentication is currently enabled
 * This respects both the config setting and any runtime toggle
 */export const isAuthEnabled=()=>{// TEMPORARY: Always disable auth for development testing
// if (process.env.NODE_ENV !== 'production') {
//   console.warn("Auth check bypassed for development!");
//   return false;
// }
// Original logic:
// Check local storage first (for runtime toggles)
const localStorageSetting=localStorage.getItem(AUTH_ENABLED_KEY);if(localStorageSetting!==null){return localStorageSetting==='true';}// Fall back to config default
console.log('AUTH_CONFIG.enabled',AUTH_CONFIG.enabled);return AUTH_CONFIG.enabled;};/**
 * Enable authentication
 */export const enableAuth=()=>{localStorage.setItem(AUTH_ENABLED_KEY,'true');console.log('Authentication enabled');// Remove any debug tokens when enabling auth
localStorage.removeItem(DEBUG_TOKEN_KEY);};/**
 * Disable authentication
 */export const disableAuth=()=>{localStorage.setItem(AUTH_ENABLED_KEY,'false');console.log('Authentication disabled');// Set debug token when disabling auth
setDebugToken(AUTH_CONFIG.debugToken);};/**
 * Get the current debug token if auth is disabled
 */export const getDebugToken=()=>{if(isAuthEnabled()){return null;}return localStorage.getItem(DEBUG_TOKEN_KEY)||AUTH_CONFIG.debugToken;};/**
 * Set a debug token (only works when auth is disabled)
 */export const setDebugToken=token=>{if(!isAuthEnabled()){localStorage.setItem(DEBUG_TOKEN_KEY,token);}};// Add global window methods for easy toggling during development
if(process.env.NODE_ENV!=='production'){window.enableAuth=enableAuth;window.disableAuth=disableAuth;window.getAuthStatus=()=>({enabled:isAuthEnabled(),debugToken:getDebugToken()});}const authUtils={isAuthEnabled,enableAuth,disableAuth,getDebugToken,setDebugToken};export default authUtils;